import { React, useEffect, useState } from "react";
import axios from "axios";
import { PublicResearchList, PublicResearchPositionOverview } from "..";

function ResearchDisplay() {
    const [researchPositions, setResearchPositions] = useState([]);
    const [selectedResearchPosition, setSelectedResearchPosition] = useState({});
    const [isLoaded, setLoaded] = useState(false);
    
    const getResearchPositions = () => {
        axios.get("/faculty/getResearchPositions").then((res) => {
            const data = res.data;
            if (data.success) {
                setResearchPositions(data.researchPositions);
                setSelectedResearchPosition(data.researchPositions[0]);   
            }
        });
    };

    const handleSelectedResearchPosition = (researchPosition) => {
        setSelectedResearchPosition(researchPosition);
    };

    useEffect(() => {
        if(!isLoaded) {
            getResearchPositions();
            setLoaded(true);
        }
    });

    return (
        <div className="bg-brand-tertiary">
            <div className="w-[30%] h-screen inline-block p-2">
                <PublicResearchList
                    researchPositions={researchPositions}
                    selectedResearchPosition={selectedResearchPosition}
                    setResearchPosition={handleSelectedResearchPosition}
                />
            </div>
            <div className="w-[70%] h-screen inline-block align-top p-2">
                <PublicResearchPositionOverview
                    researchPosition={selectedResearchPosition}
                />
            </div>
        </div>
    );
}
export default ResearchDisplay;